import { Container } from 'react-bootstrap';

export const Gdpr = () => {
  return (
    <>
      <Container className='mt-5 '>
        <h1>Informace pro pacienty o zpracování osobních údajů a GDPR</h1>
        <p>
          podle nařízení Evropského parlamentu a Rady (EU) 2016/679 ze dne 27.
          dubna 2016 o ochraně fyzických osob v souvislosti se zpracováním
          osobních údajů a o volném pohybu těchto údajů a o zrušení směrnice
          95/46/ES (obecné nařízení o ochraně osobních údajů).
        </p>
      </Container>
      <Container>
        <h2>Správce osobních údajů</h2>
        <p>PhysioReact, s.r.o.</p>
        <p>
          Správce je poskytovatelem zdravotních služeb dle zákona č. 372/2011
          Sb., o zdravotních službách a podmínkách jejich poskytování, ve znění
          pozdějších předpisů.
        </p>
      </Container>
      <Container>
        <h2>Účely zpracování osobních údajů</h2>
        <p>
          Osobní údaje pacientů správce osobních údajů zpracovává zejména za
          účelem:
        </p>
        <ul>
          <li>poskytování zdravotních služeb,</li>
          <li>
            sdělování údajů o zdravotním stavu Vám a dalším oprávněným osobám
            (např. při návaznosti péče jinému poskytovateli zdravotních služeb
            či pacientem určeným osobám),
          </li>
          <li>
            organizace poskytování zdravotních údajů (zejména při objednávání
            pacientů),
          </li>
          <li>
            vedení evidence o našich příjmech a výdajích, přijatých platbách a o
            hospodaření, to vše v souladu s příslušnými právními předpisy.
          </li>
        </ul>
      </Container>
      <Container>
        <h2>Právní základ zpracování osobních údajů</h2>
        <p>
          Právním základem pro zpracování osobních údajů jsou příslušné právní
          předpisy ČR, zejména pak zákon č. 372/2011 Sb., o zdravotních službách
          a obecné nařízení o ochraně osobních údajů, a to z důvodu plnění
          závazků ze smlouvy o péči o zdraví, která dle zákona č. 89/2012 Sb.,
          občanského zákoníku ani dle zákona č. 372/2011 Sb., o zdravotních
          službách nemusí být uzavřena písemně, z důvodu nezbytnosti pro účely
          poskytování zdravotní péče a z důvodu nezbytnosti pro plnění právních
          povinností, která se na správce vztahují.
        </p>
      </Container>
      <Container>
        <h2>Příjemci osobních údajů</h2>
        <p>
          Příjemci osobních údajů mohou být v souladu s platnými právními
          předpisy v konkrétních případech kromě Vás také jiné osoby, jedná se
          zejména o:
        </p>
        <ul>
          <li>poskytovatele zdravotních služeb při návaznosti péče,</li>
          <li>
            osoby oprávněné nahlížet do zdravotnické dokumentace, a to dle
            zákona č. 372/2011 Sb., o zdravotních službách,
          </li>
          <li>
            další zpracovatele, a to na základě smluv o zpracování osobních
            údajů uzavřených v souladu s obecným nařízením o ochraně osobních
            údajů.
          </li>
        </ul>
        <p>Osobní údaje pacientů nejsou předávány do zahraničí.</p>
      </Container>
      <Container>
        <h2>Doba zpracování osobních údajů</h2>
        <p>
          Osobní údaje obsažené ve zdravotnické dokumentaci jsou zpracovávány v
          souladu s vyhláškou č. 98/2012 Sb., o zdravotnické dokumentaci, ve
          znění pozdějších předpisů. Osobní údaje zpracovávané pro další účely
          výše uvedené jsou zpracovávány po dobu stanovenou právními předpisy
          nebo po dobu, po kterou budete naším pacientem, a následně po dobu
          pěti let poté, co prokazatelně naším pacientem přestanete být
          (prokazatelně se v tomto případě rozumí ode dne písemného oznámení, že
          přestáváte být naším pacientem).
        </p>
      </Container>
      <Container>
        <h2>Práva subjektu údajů</h2>
        <p>
          Při zpracování osobních údajů máte následující práva týkající se
          ochrany svých osobních údajů:
        </p>
        <ul>
          <li>právo požadovat od nás přístup k Vašim osobním údajům;</li>
          <li>právo na opravu Vašich osobních údajů, které zpracováváme;</li>
          <li>
            právo na omezení zpracování. Omezení zpracování znamená, že musíme
            Vaše osobní údaje, u nichž bylo zpracování omezeno, označit a po
            dobu trvání omezení je nesmíme dál zpracovávat s výjimkou jejich
            uložení.
          </li>
          <li>
            právo na výmaz osobních údajů. Právo na výmaz osobních údajů se
            vztahuje jen na osobní údaje, které zpracováváme k jiným účelům, než
            je poskytování zdravotních služeb. Údaje, které o Vás vedeme za
            účelem poskytování zdravotních služeb (např. ve zdravotnické
            dokumentaci), vymazat nesmíme;
          </li>
          <li>
            právo na přenositelnost údajů. Můžete žádat, abychom Vám Vaše osobní
            údaje poskytli za účelem jejich předání jinému správci osobních
            údajů, nebo abychom je sami předali jinému správci osobních údajů.
          </li>
          <li>
            právo podat stížnost u dozorového úřadu, a to v případě, že se
            domníváte, že zpracováním osobních údajů dochází k porušení právních
            předpisů o ochraně osobních údajů. Stížnost můžete podat u
            dozorového úřadu v místě svého obvyklého bydliště, místě výkonu
            zaměstnání nebo v místě, kde došlo k údajnému porušení. V České
            republice je dozorovým úřadem Úřad na ochranu osobních údajů, Pplk.
            Sochora 27, 170 00 Praha 7, www.uoou.cz.
          </li>
          <li>
            Právo vznést námitku proti zpracování v případě, že Vaše osobní
            údaje zpracováváme pro účely oprávněných zájmů našich nebo někoho
            dalšího (právní základy zpracování), máte kdykoliv právo vznést
            proti takovému zpracování námitku. Námitku můžete vznést na naší
            adrese uvedené v bodu 1. Pokud takovou námitku vznesete, budeme
            oprávněni v takovém zpracování pokračovat jen tehdy, pokud prokážeme
            závažné oprávněné důvody pro zpracování, které převažují nad Vašimi
            zájmy nebo právy a svobodami, a dále tehdy, pokud půjde o zpracování
            nezbytné pro určení, výkon nebo obhajobu právních nároků.
          </li>
        </ul>
      </Container>
      <Container className='mb-5'>
        <h2>Povinné zpracování a povinnost poskytnout osobní údaje</h2>
        <p>
          Zpracování Vašich osobních údajů pro účely poskytování zdravotních
          služeb je zákonným požadavkem. Neposkytnutím Vašich osobních údajů
          může znamenat, že Vám nebudeme moci poskytnout zdravotní služby, čímž
          může dojít k poškození Vašeho zdraví či přímému ohrožení života (§ 41
          odst.1 písm. d) zákona č. 372/2011 Sb., o zdravotních službách a
          podmínkách jejich poskytování). Povinnost poskytnout osobní údaje
          pacienta se týká i jeho zákonného zástupce nebo opatrovníka (§ 41
          odst. 2 zákona č. 372/2011 Sb., o zdravotních službách a podmínkách
          jejich poskytování).
        </p>
      </Container>
    </>
  );
};
